import { application } from '../application'

import HeaderController from "./header_controller"
import ScheduleController from "./schedule_controller"
import SeanceController from "./seance_controller"
import TaskController from "./task_controller"
import ShoppingCartController from "./shopping_cart_controller"
import ProfileFormController from "./profile_form_controller"
import ProductGalleryController from "./product_gallery_controller"
import EventFiltersController from "./event_filters_controller"
import EventMapController from "./event_map_controller"
import EventsViewController from "./events_view_controller"
import FieldTooltipController from "../admin/field_tooltip_controller"

application.register("header", HeaderController)
application.register("schedule", ScheduleController)
application.register("seance", SeanceController)
application.register("task", TaskController)
application.register("shopping-cart", ShoppingCartController)
application.register("profile-form", ProfileFormController)
application.register("product-gallery", ProductGalleryController)
application.register("event-filters", EventFiltersController)
application.register("event-map", EventMapController)
application.register("events-view", EventsViewController)
application.register("field-tooltip", FieldTooltipController)
